export const domainName = 'test.watt.tv'
export const dataBucket = 'dataBucket'
export const fileUploadBucket = 'fileUploadBucket'
export const trainDropWatchTimePredictionQueueUrl = 'trainDropWatchTimePredictionQueueUrl'
